import Page from 'flarum/common/components/Page';

export default class PrivacyPage extends Page {
    oninit(){
        this.content = (
            <>
                {m.trust(app.forum.attribute('info-pages.privacy-content'))}
            </>
        )
    }


    view() {
        return this.content;
    }
}
